interface EmailProvider {
  name: string;
  url: string;
}

const emailProviders: Record<string, EmailProvider> = {
  'gmail.com': { name: 'Gmail', url: 'https://mail.google.com' },
  'googlemail.com': { name: 'Gmail', url: 'https://mail.google.com' },
  'outlook.com': { name: 'Outlook', url: 'https://outlook.live.com' },
  'hotmail.com': { name: 'Outlook', url: 'https://outlook.live.com' },
  'live.com': { name: 'Outlook', url: 'https://outlook.live.com' },
  'yahoo.com': { name: 'Yahoo Mail', url: 'https://mail.yahoo.com' },
  'yahoo.co.jp': { name: 'Yahoo Mail', url: 'https://mail.yahoo.co.jp' },
  'qq.com': { name: 'QQ邮箱', url: 'https://mail.qq.com' },
  '163.com': { name: '163邮箱', url: 'https://mail.163.com' },
  '126.com': { name: '126邮箱', url: 'https://mail.126.com' },
  'sina.com': { name: '新浪邮箱', url: 'https://mail.sina.com.cn' },
  'sina.cn': { name: '新浪邮箱', url: 'https://mail.sina.com.cn' },
  'sohu.com': { name: '搜狐邮箱', url: 'https://mail.sohu.com' },
  'foxmail.com': { name: 'Foxmail', url: 'https://mail.qq.com' },
  'icloud.com': { name: 'iCloud', url: 'https://www.icloud.com/mail' },
  'me.com': { name: 'iCloud', url: 'https://www.icloud.com/mail' },
  'proton.me': { name: 'Proton Mail', url: 'https://mail.proton.me' },
  'protonmail.com': { name: 'Proton Mail', url: 'https://mail.proton.me' },
  'zoho.com': { name: 'Zoho Mail', url: 'https://mail.zoho.com' },
  'mail.com': { name: 'Mail.com', url: 'https://www.mail.com' },
  'aol.com': { name: 'AOL Mail', url: 'https://mail.aol.com' },
  'yandex.com': { name: 'Yandex Mail', url: 'https://mail.yandex.com' },
  'yandex.ru': { name: 'Yandex Mail', url: 'https://mail.yandex.ru' },
  'gmx.com': { name: 'GMX', url: 'https://www.gmx.com' },
  'gmx.de': { name: 'GMX', url: 'https://www.gmx.de' },
};

export function getEmailProvider(email: string): EmailProvider | null {
  if (!email || !email.includes('@')) {
    return null;
  }

  const domain = email.split('@')[1]?.toLowerCase();
  if (!domain) {
    return null;
  }

  return emailProviders[domain] || null;
}

export function getEmailProviderUrl(email: string): string | null {
  const provider = getEmailProvider(email);
  return provider?.url || null;
}

export function getEmailProviderName(email: string): string | null {
  const provider = getEmailProvider(email);
  return provider?.name || null;
}
